
module.exports = function promiseCreator() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej){
        resolve = res;
        reject = rej;
    });
    return {
        resolve: resolve,
        reject: reject,
        promise: promise
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/promise-creator/promise-creator.js
// module id = 37
// module chunks = 58